import { bindStateToDb } from '@/utilities/db-helpers'

const favourites = {
  namespaced: true,

  state: () => ({
    favourites: {},
  }),

  getters: {
    uid: (state, getters, rootState, rootGetters) =>
      rootGetters[`accounts/user`].uid,

    isFaved({ favourites }) {
      return id => favourites[id]
    },

    getFavourites({ favourites }) {
      return Object.keys(favourites || {}).map(id => ({ id }))
    },
  },

  actions: {
    bindFavouritesRef: bindStateToDb(`favourites`, `userFavourites`),

    fave(
      {
        dispatch,
        getters: { uid },
      },
      { id }
    ) {
      const updates = {}
      // add to favourites
      updates[`/userFavourites/${uid}/${id}`] = true
      updates[`/favouriteUsers/${id}/${uid}`] = true
      return dispatch(`updateDb`, updates, { root: true })
    },

    unfave(
      {
        dispatch,
        getters: { uid },
      },
      { id }
    ) {
      const updates = {}
      // add to favourites
      updates[`/userFavourites/${uid}/${id}`] = null
      updates[`/favouriteUsers/${id}/${uid}`] = null
      return dispatch(`updateDb`, updates, { root: true })
    },

    addToBattle(
      {
        dispatch,
        rootGetters: { [`battles/battle`]: battle },
      },
      { id }
    ) {
      const updates = {}
      updates[`/combatants/${id}/battles/${battle}`] = true
      updates[`/battleCombatants/${battle}/${id}/meta/id`] = id
      return dispatch(`updateDb`, updates, { root: true })
    },
  },
}

export default favourites
